import { RewardsBalanceAction, RewardsBalanceActionTypes } from './rewardsBalanceActionType';
import { IRewardsBalanceState } from '../../rewardsClub.interface';

const initialState: IRewardsBalanceState = {
    allRewards: [],
    superPointsBalance: 0,
    pendingPointsBalance: 0,
    termDetails: [],
    fetching: false,
    error: null,
};

export function rewardsBalanceReducer(state = initialState, action: RewardsBalanceAction) {
    switch (action.type) {
        case RewardsBalanceActionTypes.LOADING_CASHBACK_AND_POINTS_PAGE:
            return { ...state, error: null, fetching: false };
        case RewardsBalanceActionTypes.GET_ALL_REWARDS_BALANCES_REQUEST:
            return { ...state, fetching: true };
        case RewardsBalanceActionTypes.GET_ALL_REWARDS_BALANCES_SUCCESS:
            return {
                ...state,
                allRewards: action.rewardsBalanceResponse,
                fetching: false,
                error: null,
            };
        case RewardsBalanceActionTypes.GET_ALL_REWARDS_BALANCES_FAILURE:
            return { ...state, error: action.error, fetching: false };
        default:
            return state;
    }
}
